<template>
  <div class='navContainer'>
    <b-nav vertical class="mailboxNav">
      <b-nav-item class="active">
        Filters
      </b-nav-item>
      <b-nav-item  v-for="(searchKey, index) in searchKeys" :key="index" @click="showDropdown(searchKey)">
        <span class='menu-left'>{{searchKey}}</span>
      </b-nav-item>
      <b-nav-item class="back" @click="$router.go(-1)">Back
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
export default {
  name: 'NavSearch',
  data () {
    return {
      searchKeys: [
        'client',
        'assigned',
        'customer',
        'mailbox',
        'status',
        'subject',
        'tag',
        'body',
        'id',
        'after',
        'before',
        'between',
        'on'
      ]
    }
  },
  methods: {
    showDropdown (searchKey) {
      this.$root.$emit('searchKeyClicked', searchKey)
    }
  }
}
</script>
<style scoped>
  a {
    color: #f5f5f5;
  }
  .menu-left {
    padding: 5px;
    display: block;
    float: left;
  }
  .menu-left {
    padding: 5px;
    display: block;
    float: left;
  }
  .navContainer {
    margin: 7px;
  }
  .back:hover {
    background: #3D829A;
  }
  .back a {
    color: #f5f5f5;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavSearch.vue